import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import BaseMixin from './BaseMixin';

const Conjunction = createReactClass({
  displayName: 'Conjunction',
  mixins: [BaseMixin],

  propTypes: {
    onConjunctionChange: PropTypes.func
  },

  render: function() {
    return (
      <div className="conjunction">
        <select
          className="form-control"
          value={this.props.node.get('terminal')}
          onChange={this._onChange}
          disabled={!this.props.editable}
        >
          <option value="and">and</option>
          <option value="or">or</option>
        </select>
      </div>
    );
  },

  _onChange: function(evt) {
    this.props.node.set('terminal', evt.target.value);
  }
});

export default Conjunction;
